// 使用方法回调的方式进行扩展
import { ViewModel, pageTo, getAppUrl, getTopWindow } from '@platform/api'
import * as feConfig from './const';

// 这个东西呢  有三种做法  i.变量（get set）  ii.静态变量（static）  iii.全局变量
const ExtendModuleName = 'NCCExtend';

const srcriptAlreadyExist = src => {
    let allScript = document.getElementsByTagName('script');
    let srcriptUrl = Array.from(allScript).map(element => {
        return element.getAttribute('src');
    });
    let index = srcriptUrl.findIndex(val => val === src);
    return index !== -1;
};
//liuming CONFIG引用修改
const isPageModal = true
/**
 * 查找resources加载的文件路径里某一层级的文件名
 * n:Number 在resources的第几层
 */
function getUrlPathName(n) {
    // hash 示例
    // "ifr=/nccloud/resources/price/price/adjustprice/main/index.html#/list&c=403000800&p=403000800_list&ar=0001Z81000000003QAX4&n=价格调整单&b1=供应链&b2=销售价格&b3=销售调价"
    let hash = '';
    if (isPageModal) {
        let pageStore = getAppUrl().pageurl;
        hash = decodeURIComponent(decodeURIComponent(pageStore));
    } else {
        hash = decodeURIComponent(decodeURIComponent(getTopWindow().location.hash));
    }
    let matchStr = hash.match(/ifr=\/nccloud\/resources\/(\S*).html/) || hash.match(/ifr=\/(\S*).html/);
    let urlPathArr = matchStr && matchStr[1] && matchStr[1].split('/') || ['none+', 'none+'];
    return urlPathArr[n];
}

/**
 * 获取扩展路径
 */
function getExtendUrl(billinfo = {}) {
    console.log(billinfo, '页面基础信息');
    let domainCode = getUrlPathName(0),
        moduleCode = getUrlPathName(1),
        nodePath = getUrlPathName(2),
        appcode = billinfo.appcode || pageTo.getAppCode(),
        pagecode = billinfo.pagecode || pageTo.getPageCode();

    let appCodeUrl = domainCode && moduleCode && appcode && pagecode ? `extend_${domainCode}/${moduleCode}/${appcode}/${pagecode}` : null;
    let appPathUrl = domainCode && moduleCode && nodePath && pagecode ? `extend_${domainCode}/${moduleCode}/${nodePath}/${pagecode}` : null;
    // console.log(domainCode, moduleCode, appcode, pagecode);
    return {
        appPathUrl,
        appCodeUrl,
    }
}

class MethodsModel {
    constructor() {
        this.extendPath = '';
        this.billinfo = null;
        this.extendUrl = '';
        this.script = null;
        this.successFunc = null;
        this.src = '';
        this.loadAppPath = false;
        this.isReadyLoad = false;
        // 是否开启了扩展开发
        this.isEnabled = pageTo.getSearchParam('sec_develop') === 'Y';
    }

    loadScript = () => {
        this.extendPath = `${ExtendModuleName}/${this.extendUrl}/index`;
        this.script = document.createElement('script');
        this.script.type = 'text/javascript';
        this.script.src = this.src;
        if ( this.script.readyState) {
            this.script.addEventListener('readstatechange', this.readStateChange);
        } else {
            this.script.addEventListener('load', this.saveMethods);
        }

        this.script.onerror = this.onError;

        try {
            document.body && document.body.appendChild(this.script);
            // script = null;
        } catch (e) {
            console.log(this.extendPath + 'script load error , not found src');
        }

    }

    onError = () => {
        console.log(this.extendPath + 'script load error , not found src');
        this.removeScript(this.src);
        this.extendUrl = getExtendUrl( this.billinfo).appPathUrl;
        this.src = `../../../../${ExtendModuleName}/${this.extendUrl}/index.js`;
        if(this.extendUrl && !this.loadAppPath){
            this.loadAppPath = true;
            this.loadScript(this.extendUrl); 
            
        }     
    }

    readStateChange = () => {
        if (this.script.readyState === 'loaded' || this.script.readyState === 'complete') {
            this.script.removeEventListener('readstatechange', this.readStateChange);
        }
    }

    saveMethods = () => {
        let allMethods = null;
        // 二开注册对象 export default 输出
        if (window[this.extendPath] instanceof Object && window[this.extendPath].default instanceof Object) {
            allMethods = window[this.extendPath].default;
        } else if (window[ExtendModuleName] instanceof Object) { //二开注册对象挂在 window.NCCExtend
            allMethods = window[ExtendModuleName];
        }
        // if (window[ExtendModuleName] instanceof Object) {
        if (allMethods) {
            let extendCache = ViewModel.getData('_nccloud_extend_cache_data') || {};
            if (!extendCache[this.extendUrl]) {
                extendCache[this.extendUrl] = {};
            }
            // 提供两个方法给  模板加载和数据加载使用
            if (allMethods.dataAlreadyLoaded && typeof allMethods.dataAlreadyLoaded === 'function') {
                extendCache[this.extendUrl].dataAlreadyLoaded = allMethods.dataAlreadyLoaded;
            }
            if (allMethods.templateAlreadyLoaded && typeof allMethods.templateAlreadyLoaded === 'function') {
                extendCache[this.extendUrl].templateAlreadyLoaded = allMethods.templateAlreadyLoaded;
            }
            if (allMethods.beforeAjaxSend && typeof allMethods.beforeAjaxSend === 'function') {
                extendCache[this.extendUrl].beforeAjaxSend = allMethods.beforeAjaxSend;
            }

            if (allMethods.localExtendRouter && typeof allMethods.localExtendRouter === 'function') {
                extendCache[this.extendUrl].localExtendRouter = allMethods.localExtendRouter;
            }
            ViewModel.setData('_nccloud_extend_cache_data', extendCache);
            this.isReadyLoad = true;
            this.successFunc(allMethods);
        }
    }

    // 加载文件 mutativeLoadScrip
    install = (callback, { billinfo }) => {
        if (pageTo.getSearchParam('sec_develop') !== 'Y') {
            return;
        }
        if (!feConfig.enable) {
            console.log('本页面禁止加载二开文件~');
            return false;
        }
        // 缓存数据
        this.billinfo = billinfo;
        this.successFunc = callback;
        //加载二开的文件--liuxis
        this.extendUrl = getExtendUrl(billinfo).appCodeUrl;
        this.src = `../../../../${ExtendModuleName}/${this.extendUrl}/index.js`;
        if (this.extendUrl) {
            this.loadScript(this.extendUrl); 
        }
    }

    // 移除文件
    removeScript = src => {
        let $script = document.querySelector(`[src="${src}"]`);
        $script && document.body.removeChild($script);
    }

    // 卸载文件
    unstall = () => {
        // TODO 卸载二开文件
        //销毁二开绑定在window上的事件
        //this.extendUrl = getExtendUrl(this.billinfo);
        if (this.extendUrl) {
            // let name = `NCCExtend${appcode}_${pagecode}`;
            if (window[ExtendModuleName]) window[ExtendModuleName] = null;
            let extendCache = ViewModel.getData('_nccloud_extend_cache_data');
            if (extendCache) {
                extendCache[this.extendUrl] = null;
            }
            this.removeScript(`../../../../${ExtendModuleName}/${this.extendUrl}/index.js`);
        }
    }
}

export default MethodsModel;